import { render, staticRenderFns } from "./RoleBadge.vue?vue&type=template&id=353e451a&scoped=true&"
import script from "./RoleBadge.vue?vue&type=script&lang=ts&"
export * from "./RoleBadge.vue?vue&type=script&lang=ts&"
import style0 from "./RoleBadge.vue?vue&type=style&index=0&id=353e451a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e451a",
  null
  
)

export default component.exports